import { useState, useEffect, useRef, DragEventHandler } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { AdminService } from "../../../../services/AdminService";
import { closelightbox } from "../../../../util/Functions";
import { readCsvFile } from "../../../../util/ReadCsvFile";

export const useMassExpedient = (open: boolean, data: any, changeAlert: ChangeAlertCallbackType) => {
	const adminService = useRef<AdminService>();
    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [form, setForm] = useState({});
    const [failedData, setFailedData] = useState(null);

    const [zPos, setZPos] = useState(45);
    const [loading, setLoading] = useState(false);
    const dropZoneRef = useRef<null | HTMLDivElement>(null);
	

    const onConfirm = async (customers) => {
        setLoading(true);
        setZPos(-1);

		let errors = null;

		try {
			console.log("🔄 Generando URLs una por una...");
			const { urls, urls_error } = await processSequential(customers);
			urls_error.length > 0 ? setFailedData(urls_error) : setFailedData(null);

			console.log("⬇️ Generando zip...");
			// const urls = [{ url: "https://storage.googleapis.com/docs-indigo-next-sbx/expedient/574ea211-1924-4919-b3ec-2fa7b9c8454e/expedient-2025-10-23T16%3A14%3A11.635Z.pdf?GoogleAccessId=blob-storage%40albo-indigonext-sandbox.iam.gserviceaccount.com&Expires=1762100058&Signature=WJ%2BT2XcMHOQ2IAm6LELJeR3%2B9mIvqLXFEyF7jJSXZPRvGvzn8SvHNmlp76HNenC2ntmgaOaIht7pOgOxVqJ8e3cHXQOK7GA5arhAmTXN26Nm6PRKTyDgnHCi0nht%2B5OeVRCHayRR%2BNUQluMQAB13oJrVVKTN%2BjtpFODQlA%2Bgw7%2FuEy7idE3tjlgqNcLc2woVosNsDTu4wG9hZqACOp7Zx4jun33QVPB3sNj1kckzT00oh%2F7eOeqcBO4FeFcYTPOYXndLUVnBKqGTsh%2BINGVen9cMr0O1cX596NsZEzEL66KnQpQuh4MlQH9RNC0V3D7KNWGmxJ105e2QHATIfMEnjw%3D%3D", uuid: "2121212"}]
			if (urls.length > 0) {
				const generateZip = await onGenerateZip(urls);
				console.log('generateZip: ', generateZip);
				if (generateZip) {
					const byteCharacters = atob(generateZip);
					const byteNumbers = Array.from(byteCharacters).map(c => c.charCodeAt(0));
					const blob = new Blob([new Uint8Array(byteNumbers)], { type: 'application/zip' });
					
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = 'archivo.zip';
					link.click();
				} else {
					console.error("❌ Error al generar ZIP",);
				}
			}

			if (urls_error.length > 0) {
				errors = urls_error;
				setIsValidForm(true);
			} else {
				errors = null;
				setIsValidForm(false);
			}
			console.log("✅ Proceso completado");
		} catch (error) {
			console.error("❌ Error:", error);
		}
		
		changeAlert(true, "success", "La descarga finalizó con éxito");
		!errors && onClose();

        setZPos(45);
        setLoading(false);
    };

	const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	async function processSequential(ids, delay = 14000) {
		const urls = [];
		const urls_error = [];

		for (const id of ids) {
			try {
				const res = await adminService.current.downloadInfo({customerUuid: id});
				if (res.data.response !== "OK") throw new Error(`Error con el id ${id}`);

				const data = await res?.data?.files[0];
				urls.push({url: data, uuid: id});

				console.log(`✅ URL generada para ${id}`);
			} catch (err) {
				urls_error.push(id);
				console.error(`❌ Error al procesar ${id}:`, err);
			}
			await sleep(delay);
		}

		console.log('Lista de URL´s: ', urls);
		console.log('Lista de URL´s fallidas: ', urls_error);
		
		return { urls, urls_error };
	}

	async function onGenerateZip(urls) {
		try {
			const res = await adminService.current.generateZip(urls);
			if (res.data.response !== "OK") throw new Error(`Error al generar ZIP.`);
			const data = await res?.data?.content;
			return data;
		} catch (err) {
			console.error(`❌ Error al procesar data:`, err);
			return false;
		}
	}

	const onClose = () => {
		onHandleReset();
        closelightbox();
	};

	const parseJson = async (selectedFile) => {
        setLoading(true);
        setZPos(-1);

		const request = await readCsvFile(selectedFile, 50);
		if (request) {
			setForm(JSON.parse(JSON.stringify(request)));
			setIsValidForm(false);
		} else {
			changeAlert(true, "error", "Ocurrió un error, por favor intenta de nuevo.");
		}

        setLoading(false);
        setZPos(45);
    };

	const onSelectFile = (e) => {
        let csv = e.target.files[0];
        let extension = (name) => {
            return ["csv", "xls", "xlsx"].indexOf(name.split('.').pop()) === -1 ? true : false
        }

        if (!csv) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (extension(csv.name)) {
            changeAlert(true, "error", "Error: El tipo de archivo no es permitido.");
        } else {
            parseJson(csv);
        }
    };

	const handleOver: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (dropZoneRef.current) {
			dropZoneRef.current.style.borderColor = "#1890ff";
			dropZoneRef.current.style.borderWidth = "2px";
			dropZoneRef.current.style.backgroundColor = "rgba(119, 119, 255,0.1)";
		}
	};

	const handleLeave: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();
		if (dropZoneRef.current) {
			dropZoneRef.current.style.borderColor = "lightgray";
			dropZoneRef.current.style.borderWidth = "1px";
			dropZoneRef.current.style.backgroundColor = "transparent";
		}
	};

	const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
		event.preventDefault();
		event.stopPropagation();

		if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
			const filesToUpload = [];
			for (let i = 0; i < event.dataTransfer.files.length; i++) {
				filesToUpload.push(event.dataTransfer.files.item(i));
			}

			if (filesToUpload.length > 0) {
				parseJson(filesToUpload[0]);
				handleLeave(event);
			}
			event.dataTransfer.clearData();
		}
	};

	const onHandleReset = () => {
		setIsValidForm(true);
		setForm({});
		setZPos(45);
		setLoading(false);
	};
	
    const onFormReset = () => {
        setForm(null);
        setIsValidForm(true);
    };

    useEffect(() => {
        if (!open) {
            onHandleReset();
		}
        adminService.current = new AdminService(changeAlert);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

	return {
        zPos,
        form,
        loading,
        isValidForm,
        dropZoneRef,
		failedData,
        onConfirm,
		onSelectFile,
        onFormReset,
        handleOver,
        handleLeave,
        handleDrop,
		onClose
    };
};
